var map = {
	"./audio_1_0.mp3": 1352,
	"./audio_1_1.mp3": 1353,
	"./audio_1_2a.mp3": 1354,
	"./audio_1_2b.mp3": 1355,
	"./audio_1_3.mp3": 1356,
	"./audio_1_4.mp3": 1357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1351;